import { Checkbox, FormControlLabel, Link } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'

import style from './PersonalAgreement.module.scss'

const PersonalAgreement = ({
  agreement,
  setAgreement,
}: {
  agreement: boolean
  setAgreement: Dispatch<SetStateAction<boolean>>
}) => {
  const handleChange = () => {
    setAgreement(prev => !prev)
  }
  return (
    <div className={style.personalagreement}>
      <FormControlLabel
        control={
          <Checkbox
            value={agreement}
            onChange={handleChange}
            data-testid='sms-personal-agree'
          />
        }
        label={
          <>
            <span>Согласен на </span>
            <Link href='/personalagreement' underline='hover' target='_blank'>
              <span>обработку персональных данных</span>
              <sup>&nbsp;*</sup>
            </Link>
          </>
        }
      />
    </div>
  )
}

export default PersonalAgreement
